export function onlyCpfDigits(value: string) {
  return value.replace(/\D/g, '').slice(0, 11);
}

export function formatCpf(value: string) {
  const digits = onlyCpfDigits(value);
  return digits
    .replace(/^(\d{3})(\d)/, '$1.$2')
    .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');
}

export function isValidCpf(value: string) {
  const cpf = onlyCpfDigits(value);
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

  const calcDigit = (base: string, factor: number) => {
    const total = base.split('').reduce((sum, digit) => {
      const result = sum + Number(digit) * factor;
      factor -= 1;
      return result;
    }, 0);
    const rest = (total * 10) % 11;
    return rest === 10 ?0 : rest;
  };

  const digit1 = calcDigit(cpf.slice(0, 9), 10);
  const digit2 = calcDigit(cpf.slice(0, 10), 11);

  return digit1 === Number(cpf[9]) && digit2 === Number(cpf[10]);
}
